import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export const SignInTodo = createAsyncThunk('SignIn', async (data) => {
    try {
        const res = await axios({

            method: "POST",
            url: process.env.REACT_APP_API_URL + 'user_login',
            data: {
                "login": data.user,
                "password_hash": data.password,
                "device_type": "web"
            },
            headers: { "Content-Type": "application/json" }
        })
        return res
    } catch (error) {
        return error.response
    }
})
